import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
  export default new Vuex.Store({
    state: {
      // 要回显的数据
      imgUrl:'https://hbrsyyyxgs.com/webpic/',//https://hbrsyyyxgs.com http://www.shenhaoyaoye.com
      logoImg:'https://hbrsyyyxgs.com/',
      companyID:12,//神豪5 荣顺12
      lunboList:[],
      gongsijianjie:'',
      gongsipic:'',
      productList:[],
      companypic:{},
      companyName:'河北荣顺药业有限公司', //荣顺饮片 
      quanming:'河北荣顺药业有限公司',
      appName:'荣顺药业',
      logo:'',
      footerInfo:{},
      addresscoordinate:''
    },
    getters: {
    },
    mutations: {
        CHANGE_ADDRESSCOORDINATE: (state, addresscoordinate) => state.addresscoordinate = addresscoordinate,
      CHANGE_LUNboList: (state, lunbolist) => state.lunboList = lunbolist,
      CHANGE_LOGO: (state, logo) => state.logo =logo,
      
      CHANGE_GONGSIJIANJIE: (state, JIANJIE) => state.gongsijianjie = JIANJIE,
      CHANGE_GONGSIPIC: (state, gongsipic) => state.gongsipic = gongsipic,
      CHANGE_PRODUCTLIST: (state, productList) => state.productList = productList,
      CHANGE_COMPANYPIC: (state, companypic) => state.companypic = companypic,
      CHANGE_footerInfo: (state, footerInfo) => state.footerInfo = footerInfo,
      
    },
    actions: {
    },
    modules: {
    }
  })




// WEBPACK FOOTER //
// ./src/store/index.js